import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { IFicheExpressionBesoinResponse, FebStatut } from 'src/app/shared/models/fiche-expression-besoin';
import { FebHistoryComponent } from './feb-history/feb-history.component';

@Component({
  selector: 'app-feb-viewer',
  templateUrl: './feb-viewer.component.html',
  styleUrl: './feb-viewer.component.less'
})
export class FebViewerComponent {

  readonly FebStatut = FebStatut;

  constructor(
    public dialogRef: MatDialogRef<FebViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFicheExpressionBesoinResponse,
    private dialog: MatDialog
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  openHistory(): void {
    this.dialog.open(FebHistoryComponent, {
      data: {
        febId:    this.data.febId,
        febLabel: this.data.febLabel
      },
      width:      '800px',
      maxWidth:   '95vw',
      height:     '85vh',
      panelClass: 'history-dialog-panel',
      autoFocus:  false
    });
  }

  get statClass(): string {
    switch (this.data?.febStatut) {
      case FebStatut.CREEE:      return 'statut-cree';
      case FebStatut.EN_ATTENTE: return 'statut-en-attente';
      case FebStatut.VALIDEE:    return 'statut-validee';
      case FebStatut.ARCHIVEE:   return 'statut-archive';
      default:                   return '';
    }
  }

  get statLabel(): string {
    switch (this.data?.febStatut) {
      case FebStatut.CREEE:      return 'Créée';
      case FebStatut.EN_ATTENTE: return 'En attente';
      case FebStatut.VALIDEE:    return 'Validée';
      case FebStatut.ARCHIVEE:   return 'Archivée';
      default:                   return this.data?.febStatut ?? '';
    }
  }

  get activitesTotal(): number {
    return (this.data?.febActivites ?? [])
      .reduce((sum, a) => sum + (a.pourcentage ?? 0), 0);
  }
}